import type from "./type";

export default type("text/plain", function(xhr) {
  return xhr.responseText;
});



//////////////////
// WEBPACK FOOTER
// D:/glois.angular/~/d3-request/src/text.js
// module id = ../../../../d3-request/src/text.js
// module chunks = 4